"use client";

import { getAnalytics } from "./client";
import type { UserTraits } from "./types";

/**
 * Identify a user with Segment.
 * This should be called after successful login.
 *
 * @param userId - The unique user ID
 * @param traits - User traits (phone, createdAt, etc.)
 */
export function identify(userId: string, traits?: UserTraits): void {
  const analytics = getAnalytics();

  if (!analytics) {
    return;
  }

  // Analytics methods return void in fire-and-forget mode
  // Errors are handled internally by Segment
  analytics.identify(userId, traits);
}

/**
 * Reset the user identity in Segment.
 * This should be called on logout to clear the user's identity.
 */
export function reset(): void {
  const analytics = getAnalytics();

  if (!analytics) {
    return;
  }

  // Analytics methods return void in fire-and-forget mode
  // Errors are handled internally by Segment
  analytics.reset();
}
